// extracted by mini-css-extract-plugin
export default {"tableContainer":"_7JXBPJ0_JfBh1Bw7m5b9K","searchArea":"_2JzC_sWrfv1g8YHkVCRhS7","noSearch":"_2BsK7E7PoF5s03rkRbdqzX"};